import React, { useEffect, useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { reviewApi } from "./api";
export default function BetaConflictCheck({
  reviewId,
  attorneyId,
  onChecked,
}: {
  reviewId: string;
  attorneyId: string;
  onChecked: (version: number) => void;
}) {
  const [data, setData] = useState<any>(null),
    [result, setResult] = useState("potential"),
    [note, setNote] = useState(""),
    [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  useEffect(() => {
    const c = new AbortController();
    reviewApi(`/${reviewId}/conflicts`, "GET", undefined, c.signal)
      .then(setData)
      .catch(e => {
        if (!c.signal.aborted) setError(e.message);
      });
    return () => c.abort();
  }, [reviewId]);
  const current = data?.checks.find((c: any) => c.attorney_id === attorneyId);
  async function save() {
    setBusy(true);
    setError("");
    try {
      const r = await reviewApi(`/${reviewId}/conflict-check`, "POST", {
        version: data.version,
        attorneyId,
        result,
        note,
      });
      const d = await reviewApi(`/${reviewId}/conflicts`);
      setData(d);
      onChecked(r.version);
    } catch (e: any) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <section className="reviewed-note mt-3">
      <h3 className="h6">Conflict check</h3>
      {error && <Alert variant="danger">{error}</Alert>}
      {data ? (
        <>
          <p>
            <strong>Disclosed parties:</strong>{" "}
            {data.parties || "No beta intake — a new request is required."}
          </p>
          {current && (
            <p>
              Latest result for this attorney: <strong>{current.result}</strong>{" "}
              · {current.checked_by}
            </p>
          )}
          <Form.Label htmlFor="conflict-result">
            Result of the manual check
          </Form.Label>
          <Form.Select
            id="conflict-result"
            value={result}
            onChange={e => setResult(e.target.value)}
          >
            <option value="potential">Potential conflict — investigate</option>
            <option value="clear">Clear</option>
            <option value="conflict">Conflict — do not assign</option>
          </Form.Select>
          <Form.Label htmlFor="conflict-note" className="mt-2">
            Internal check record
          </Form.Label>
          <Form.Control
            as="textarea"
            id="conflict-note"
            value={note}
            maxLength={2000}
            rows={2}
            onChange={e => setNote(e.target.value)}
            placeholder="How and when you checked these parties for the selected attorney."
          />
          <Button
            className="mt-2"
            disabled={!attorneyId || !note.trim() || busy || !data.parties}
            onClick={save}
          >
            {busy ? "Saving…" : "Record conflict result"}
          </Button>
          <p className="small mt-2 mb-0">
            A potential or confirmed conflict blocks assignment. Waivers are
            outside this beta.
          </p>
        </>
      ) : (
        <p role="status">Loading disclosed parties…</p>
      )}
    </section>
  );
}
